import Network from 'shared/libraries/network';
import CONFIG from 'shared/constants/config';

class ShopModel extends Network {
  constructor(baseURL: string, timeout = 120000) {
    super(baseURL, timeout);
  }

  //GET
  async getShopItems<T>(): Promise<T> {
    return this.send('get', `/mini_app/shop/rock_scissors_paper`);
  }

  //POST
  async postBuyItem<T>(itemId: string): Promise<T> {
    return this.send(
      'post',
      `/mini_app/shop/rock_scissors_paper/purchase/${itemId}`,
    );
  }
}

const baseUrl: string = CONFIG.REACT_APP_API_BASE_URL as string;
const shopModel = new ShopModel(baseUrl);
export default shopModel;
